<div>
  <app-survey-division></app-survey-division>
  <app-survey-division></app-survey-division>
  <mat-paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>
